export default "__VITE_ASSET__edcf849f__"